import { render, staticRenderFns } from "./ExpandedRow.vue?vue&type=template&id=bc91e47c&scoped=true&"
import script from "./ExpandedRow.vue?vue&type=script&lang=js&"
export * from "./ExpandedRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc91e47c",
  null
  
)

export default component.exports